import { defineStore } from "pinia";

interface AuthState {
  pending2faToken: string | null;
}

export const useAuthStore = defineStore("auth", {
  state: (): AuthState => ({
    pending2faToken: null,
  }),

  actions: {
    setPending2faToken(token: string | null) {
      this.pending2faToken = token;
    },
  },
});
